import PgCodeApi from "../api/service/pgcode/PgCodeApi";

export default class PgCodeService {
    api;

    constructor() {
        this.api = new PgCodeApi();
    }

    async getPgCode({ storeId }) {
        return this.api.getPgCode({ storeId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async savePgCode(reqDto) {
        return this.api.savePgCode(reqDto).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async updatePgCode(reqDto) {
        return this.api.updatePgCode(reqDto).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }
}
